import { render } from "./MinhasFaturas.vue?vue&type=template&id=2aa052f8&scoped=true"
import script from "./MinhasFaturas.vue?vue&type=script&lang=js"
export * from "./MinhasFaturas.vue?vue&type=script&lang=js"

import "./MinhasFaturas.vue?vue&type=style&index=0&id=2aa052f8&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa052f8"]])

export default __exports__